import { createAction } from 'redux-actions';

export const SET_SELECTED_FARE_GROUP = 'SET_SELECTED_FARE_GROUP';

export const setSelectedFareGroup = createAction<string>(SET_SELECTED_FARE_GROUP);
